<template>
    <div >
         <div v-if="newDealChecker==true" >
                <div class="modal-header py-0 d-flex flex-column crm-modal-header">
                  <!-- <div class="row  px-3 pt-3 pb-1">
                    <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">{{$ml.get('ADD_OPORTUNITY')}}</h5>
                  </div>
                    <ul class="row nav hpx-50 px-3 mincrm-dynamic-tabs"  role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="deal-tab" data-toggle="tab" href="#deal" role="tab" aria-controls="deal" aria-selected="true">{{$ml.get('ADD_OPORTUNITY')}}  
                            </a>
                        </li>
                      <li class="nav-item">
                            <a class="nav-link" id="reminder-tab" data-toggle="tab" href="#reminder" role="tab" aria-controls="reminder" aria-selected="false">{{$ml.get('REMINDER')}}</a>
                      </li>
                      <li class="nav-item">
                            <a class="nav-link" id="customField-tab" data-toggle="tab" href="#deal-customField" role="tab" aria-controls="customField" aria-selected="false">{{$ml.get('SPECIAL_AREA')}}</a>
                      </li>
                      <li class="nav-item">
                            <a class="nav-link" @click="watchUpdated=watchUpdated+1" id="file-tab" data-toggle="tab" href="#deal-file" role="tab" aria-controls="file" aria-selected="false">{{$ml.get('FILE')}}</a>
                      </li>
                      
                    </ul> -->
                  <div class="row w-100">
                      <div class="col-12 pt-3 pb-1 pr-0 d-flex justify-content-center align-items-center dNone">
                        <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">{{$ml.get('ADD_OPORTUNITY')}}</h5>
                         <button type="button" @click="closeButton"  class="close "  aria-label="Close">
                          <span aria-hidden="true" class="font-40">&times;</span>
                        </button>
                      </div>
                      <div class="col-12">
                        <ul class="row nav hpx-50 px-3 mincrm-dynamic-tabs"  role="tablist">
                          <li class="nav-item">
                            <a class="nav-link active" id="deal-tab" data-toggle="tab" href="#deal" role="tab" aria-controls="deal" aria-selected="true">{{$ml.get('DETAIL_COMPANY')}}  
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" id="reminder-tab" data-toggle="tab" href="#reminder" role="tab" aria-controls="reminder" aria-selected="false">{{$ml.get('REMINDER')}}</a>
                          </li>
                        <li class="nav-item">
                            <a class="nav-link" id="customField-tab" data-toggle="tab" href="#deal-customField" role="tab" aria-controls="customField" aria-selected="false">{{$ml.get('SPECIAL_AREA')}}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" @click="watchUpdated=watchUpdated+1" id="file-tab" data-toggle="tab" href="#deal-file" role="tab" aria-controls="file" aria-selected="false">{{$ml.get('FILE')}}</a>
                        </li>
                      
                        </ul> 
                      </div>
                  </div>
                </div>

                <div class="modal-body py-2 crm-modal-body">
            <div class="tab-content">
                <div class="tab-pane fade show active py-2" id="deal" role="tabpanel" aria-labelledby="deal-tab">
                    <div class="dealStatus mb-3 p-1 div-border">
                        <div class="row m-0">
                            <div class="col-md-3 statu" id="1" @click="selectStage">
                                <button type="button" class="btn btn-sm btn-block active font-sm border-top-bottom-left-radius-4 btn-dealStatus">{{$ml.get('STEP_1')}}</button>
                            </div>
                            <div class="col-md-3 statu" id="2" @click="selectStage">
                                <button type="button" v-if="deal['stageId']>=2" class="btn btn-sm btn-block active font-sm btn-dealStatus">{{$ml.get('STEP_2')}}</button>
                                <button type="button" v-else class="btn btn-sm btn-block font-sm btn-dealStatus">{{$ml.get('STEP_2')}}</button>
                            </div>
                            <div class="col-md-3 statu" id="3" @click="selectStage">
                                <button type="button" v-if="deal['stageId']>=3" class="btn btn-sm btn-block active font-sm btn-dealStatus">{{$ml.get('STEP_3')}}</button>
                                <button type="button" v-else class="btn btn-sm btn-block font-sm btn-dealStatus">{{$ml.get('STEP_3')}}</button>
                            </div>
                            <div class="col-md-3 statu" id="4" @click="selectStage">
                                <button type="button" v-if="deal['stageId']>=4" class="btn btn-sm btn-block active font-sm border-top-bottom-right-radius-4 btn-dealStatus">{{$ml.get('STEP_4')}}</button>
                                <button type="button" v-else class="btn btn-sm btn-block font-sm border-top-bottom-right-radius-4 btn-dealStatus">{{$ml.get('STEP_4')}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <label class="new-label">{{$ml.get('OPPORTUNITY_NAME')}}*</label>
                                    <input type="text" v-model="deal['title']" class="new-input">
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="row">
                                        <div class="col-12">
                                            <label class="new-label">{{$ml.get('COMPANY_NAME')}} *</label>
                                            <input type="text" v-model="organizationsKeyword" @click="isHiddenContact=false" class="new-input">
                                            <ul class="autocomplete-results new-dropdown" v-show='isHiddenOrganization'>
                                                <li class="autocomplete-result" v-for='(result, i) in items' :key="i" @click="setResult(result,'organization')">{{result.name}}</li>
                                            </ul>

                                            <ul class="new-dropdown autocomplete-results" v-show="items.length<1 && isHiddenOrganization">  
                                                <li class="autocomplete-result"> {{$ml.get('NOT_FOUND_COMPANY')}}</li>
                                                <li class="autocomplete-result f-w-normal font-family-bold f-14" @click="addOrg=true,isHiddenOrganization=false"> {{$ml.get('ADD_COMPANY')}} <i class="fa fa-plus float-right color-primary"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div v-show="addOrg" class="col-12">
                                        <div class="row addContact">
                                            <div class="col-12 d-flex justify-content-between align-items-center fastAdd">
                                                <label class="font-m h-36 py-2 m-0"> {{$ml.get('QUICK_ADD_COMPANY')}}</label>
                                                <span class="fa fa-close font-m cursor-pointer" @click="closeOrgButton" ></span>
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('NAME')}} * </label>
                                                <input type="text" v-model="addOrgArray['name']" :placeholder="addOrgArray['name']"  class="new-input">
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('TYPE_COMPANY')}}*</label>
                                                <div class="bg-white h-36">
                                                    <v-select :options="customerType" :reduce="label => label.value" label="label" v-model="addOrgArray['isCandidate']" :searchable="false"/>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('PHONE')}}*</label>
                                                <input type="number" onwheel="this.blur()" v-model="addOrgArray['phone']"  class="new-input">
                                            </div>
                                            <div class="col-12 organizationBtnStyle my-2">
                                                <button @click="saveOrgButton" class="btn-new save mcBgDark">{{$ml.get('SAVE')}}</button>
                                                <button @click="closeOrgButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="d-flex justify-content-between ">
                                        <label class="new-label">{{$ml.get('VALUE')}}</label>
                                        <label class="new-label">{{$ml.get('CURRENCY')}}</label>
                                    </div>
                                    <div class="input-group d-flex currency-group">
                                        <!-- <input type="number" v-model.number="deal['value']" class="col-7 col-md-8 new-input form-control" style="height: 45px;"> -->
                                         <input type="number" v-model.number="deal['value']" class="col-7 col-md-8 new-input form-control" style="height: 40px;">
                                        <select class="custom-select" style="height: 40px;" v-model="deal['currency']" @change="changeCurrency($event)">
                                            <option v-for="(cur,ind) in currencyData()" v-bind:key="ind" :value="cur.id">{{cur.label}}</option>
                                        </select>
                                        
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-12">
                                            <label class="new-label">{{$ml.get('PERSON')}}*</label>
                                            <input type="text" v-model="contactKeyword" @click="quickContact()" class="new-input">
                                            <ul class="autocomplete-results new-dropdown" v-show='isHiddenContact'>
                                                <li class="autocomplete-result" v-for='(result, i) in items' :key="i" @click="setResult(result,'contact')">{{result.n}} {{result.sn}}</li>
                                            </ul>
                                            <ul class="new-dropdown autocomplete-results" v-show="items.length<1 && isHiddenContact">  
                                                <li class="autocomplete-result"> {{$ml.get('NOT_FOUND_PERSON')}}</li>
                                                <li class="autocomplete-result f-w-normal font-family-bold f-14" @click="addContact=true,isHiddenContact=false"> {{$ml.get('ADD_PERSON')}} <i class="fa fa-plus float-right color-primary"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div v-show="addContact" class="col-12">
                                        <div class="row addContact">
                                            <div class="col-12 d-flex justify-content-between align-items-center fastAdd">
                                                <label class="font-m h-36 py-2 m-0"> {{$ml.get('QUICK_ADD_CONTACT')}}</label>
                                                <span class="fa fa-close font-m cursor-pointer" @click="closeContactButton" ></span>
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('NAME')}} {{$ml.get('SURNAME')}}* </label>
                                                <input type="text" v-model="addContactArray['name']" :placeholder="addContactArray['name']"  class="new-input">
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">Gsm*</label>
                                                <input type="number" onwheel="this.blur()" v-model="addContactArray['gsm']"  class="new-input">
                                            </div>
                                            <div class="col-12">
                                                <label class="new-label">{{$ml.get('E_MAIL')}}*</label>
                                                <input type="text" v-model="addContactArray['mail']"  class="new-input">
                                            </div>
                                            <div class="col-12 organizationBtnStyle my-2">
                                                <button @click="saveContactButton" class="btn-new save mcBgDark">{{$ml.get('SAVE')}}</button>
                                                <button @click="closeContactButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="addContact" v-show="isNewOrganization&&organizationId&&contactId!==''">
                                        <div class="col-12 dealBtnStyle mt-2">
                                            <label class="f-w-normal font-family-bold text-danger f-14">{{$ml.get('RELATION_CONTACT_TO_ORGANIZATION')}}</label>
                                            <button @click="relationButton" class="btn-new save">{{$ml.get('RELATION_CONTACT_TO_ORGANIZATION_BTN')}}</button>
                                            <button @click="relationCancelButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="row">
                                        <div class="col-12">
                                            <label class="new-label">{{$ml.get('ASSOCIATE_WITH_PRODUCT')}}</label>
                                            <input type="text" v-model="productKeyword" class="new-input">
                                            <ul class="new-dropdown autocomplete-results" v-show='isHiddenProduct'>
                                                <li class="autocomplete-result" v-for='(result, i) in items' :key="i" @click="setResult(result,'product')">{{result.name}}</li>
                                                <li class="autocomplete-result" v-if="items.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="row mt-3" >
                                        <div class="col-12" >
                                            <table class="mcTable" style="border: 1px solid #dedfe1;">
                                                <thead>
                                                    <tr>
                                                        <th>{{$ml.get('PRODUCT_NAME')}}</th>
                                                        <th>{{$ml.get('PRICE')}}</th>
                                                        <th>{{$ml.get('PIECE')}}</th>
                                                        <th>{{$ml.get('DISCOUNT')}}(%)</th>
                                                        <th>{{$ml.get('TOTAL')}}</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(i,index) in product" :key="index">
                                                        <td class="w-100">{{i.name}}</td>
                                                        <td v-if="i.prices!=undefined">
                                                            <span v-if="i.prices.find(price => price.currency==deal['currency'])!=undefined">
                                                                {{i.prices.find(price => price.currency==deal['currency']).price}}
                                                            </span>
                                                            <span v-else>0</span>
                                                        </td>
                                                        <td v-else>0</td>
                                                        <td v-if="i.prices!==undefined"><input type="number" onwheel="this.blur()" min="0" class="w-100" style="text-align: center;border: 0px;" @input="updateProductPriceList()" value="1" v-model.number="selectedProductList[index].quantity"/> </td>
                                                        <td v-if="i.prices!==undefined"><input type="number" onwheel="this.blur()" min="0" max="100" class="w-100" style="text-align: center;border: 0px;" @input="updateProductPriceList()" value="0" v-model.number="selectedProductList[index].discountPercentage"/></td>
                                                        <td v-if="i.prices===undefined"><input type="number" onwheel="this.blur()" min="0" class="w-100" style="text-align: center;border: 0px;" @input="updateProductPriceList()" value="1" v-model.number="selectedProductList[index].quantity"/> </td>
                                                        <td v-if="i.prices===undefined"><input type="number" onwheel="this.blur()" min="0" max="100" class="w-100" style="text-align: center;border: 0px;" @input="updateProductPriceList()" value="0" v-model.number="selectedProductList[index].discountPercentage"/></td>
                                                        <td v-text="selectedProductList[index].totalPrice"></td>
                                                        <td><i style="padding-right: 6px;" @click="removeProduct(index)" class="icon-line-iptal f-14"></i></td>
                                                    </tr>
                                                    <tr v-show="product.length<1">
                                                        <td>{{$ml.get('NO_PRODUCT_ASSOCIATED')}}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-6 pr-2">
                                            <label class="new-label">{{$ml.get('ESTIMATED_CLOSING')}}</label>
                                            <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="estimated-closed-date"  :label="$ml.get('SELECT_DATE')" class="new-ctk" v-model="deal['expectedDate']" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                                        </div>
                                        <div class="col-6 pl-2">
                                            <label class="new-label">{{$ml.get('PROBABILITY_PERCENTAGE')}}</label>
                                            <div class="inputInfo">
                                                <input type="text" value="20" disabled class="new-input input-readonly">
                                                <span class="bg-gray position-absolute">%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-6 pr-2">
                                                    <label class="new-label">{{$ml.get('SOURCE')}}</label>
                                                    
                                                    <div class="wrapSelect bg-white">
                                                        <v-select :options="soruceTitle" :reduce="label => label.value" label="label" v-model="deal['source']" :searchable="false"/>
                                                    </div>
                                                </div>
                                                <div class="col-6 pl-2">
                                                    <label class="new-label">{{$ml.get('DEGREE')}}</label>
                                                    <div class="wrapSelect bg-white rateIcon">
                                                        <v-select :options="rateTitle" :reduce="label => label.value" label="label" v-model="deal['rate']" :searchable="false"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <label class="new-label">{{$ml.get('NOTE')}}</label>
                                            <textarea type="text" v-if="!listenStateStatus" v-model="note" class="new-textarea"></textarea>
                                            <div v-else>
                                                <input v-model="addNote" type="text" placeholder="Not Ekle..." class="updateInput font-family-bold f-14 f-w-normal">
                                                <i @click="addNoteFunc" class="icon-line-yesiltik btn-click"></i>
                                                <i class="icon-line-iptal iptal btn-click"></i>
                    
                                                <div v-if="deal['notes']!=undefined">
                                                    <showNotePanel :data="deal['notes']"  :users="this.users"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade py-2" id="reminder" role="tabpanel" aria-labelledby="reminder-tab">
                    <reminderPanel :reminders="reminders"  @updateRemindersData="updateRemindersData" />
                </div>
                <div class="tab-pane fade py-2" id="deal-customField" role="tabpanel" aria-labelledby="customField-tab">
                    <div class="w-100" v-show="customFieldArray.length>0">
                        <special-area type="save" ref="customFields" postField="deal" :user="user" :edit="listenStateStatus" :editArray="$store.state.editLine" :users="users" @returnCustomField="returnCustomField=$event" :customField="this.customFieldArray"></special-area>
                    </div>
                </div>
                <div class="tab-pane fade py-2" id="deal-file" role="tabpanel" aria-labelledby="file-tab">
                    <file :activite="dealId"
                          :watchUpdated="watchUpdated"
                          :customerFiles="customerFiles"
                          @showCustomerFile="showCustomerFile($event)"
                          @addNewFile="addNewFile($event)" 
                          @deleteFile="function($event){ 
                                    for(k in this.customerFiles){
                                    if(this.customerFiles[k]['oid']==$event['oid']){
                                        this.customerFiles.splice(k,1)
                                    }
                                }}"
                      ></file>
                </div>
            </div>
           
              </div>
              <div class="row py-3 mx-0 crm-modal-footer stickyBtn">
                <hr class="col-12 d-none d-md-none mt-0">
                <div class="col-12 dealBtnStyle " v-if="listenStateStatus===false">
                    <button @click="saveButton" class="btn-new save ml-2">{{$ml.get('SAVE')}}</button>
                    <!-- <button @click="saveButton" class="btn-new save-and-create-bid float-left ml-0">{{$ml.get('SAVE_AND_CREATE_BID')}}</button> -->
                    <button type="button" @click="openSaveAndCreateModal" class="btn-new save-and-create-bid ml-2 btnFooterMobil" data-toggle="modal" data-target="#save-and-create-bid">
                            {{$ml.get('SAVE_AND_CREATE_BID')}}
                    </button>
                    <button @click="closeButton" class="btn-new btnFooterMobil">{{$ml.get('CANCEL')}}</button>

                    <button @click="closeButton" class="btn-new btnFooterDesktop">{{$ml.get('CANCEL')}}</button>
                    <button type="button" @click="openSaveAndCreateModal" class="btn-new save-and-create-bid ml-2 btnFooterDesktop" data-toggle="modal" data-target="#save-and-create-bid">
                            {{$ml.get('SAVE_AND_CREATE_BID')}}
                    </button>
                   
                </div>
                <div class="col-12 dealBtnStyle" v-if="listenStateStatus">
                    <button @click="saveButton" class="btn-new save ml-2">{{$ml.get('EDIT')}}</button>
                    <button @click="saveButton" class="btn-new save-and-create-bid ml-2">{{$ml.get('SAVE_AND_CREATE_BID')}}</button>
                    <button @click="closeButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
                    <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
                         Launch demo modal
                    </button> -->
                    <button @click="closeButton" class="btn-new btnFooterDesktop">{{$ml.get('CANCEL')}}</button>
                    <button @click="saveButton" class="btn-new save-and-create-bid ml-2 btnFooterDesktop">{{$ml.get('SAVE_AND_CREATE_BID')}}</button>
                    
                </div>
            </div>
         </div>
        <!-- Hızlı teklif oluştur modal -->
        <div v-else>
            <!-- <div class="modal-header py-0" >
              <h5 class="modal-title p-2 ">{{$ml.get('QUICK_BID_CREATION')}}</h5>
            </div> -->
            <div class="modal-header py-3">
                <h5 class="modal-title" >{{$ml.get('QUICK_BID_CREATION')}}</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
           </div>
            <div class="modal-body pt-3 px-md-4 crm-modal-body">
             <div class="row">
                <div class="col-12 mb-3">
                    <label class="new-label">{{$ml.get('TEMPLATE')}}*</label>                            
                      <div class="wrapSelect bg-white">
                          <select class="new-input mb-3 bg-white" @change="chooseTemplate($event)">
                              <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                              <option v-for="template in emailTemplates">{{template.name}}</option>
                          </select>
                      </div>
                </div>
             </div>
             <div class="row">
                 <div class="col-12 ">
                    <label class="new-label">{{$ml.get('COMPANY')}}*</label>                             
                      
                      <input type="text" disabled v-model="organizationsWord" @click="isHiddenContact=false" class="new-input">
                 </div>
             </div>
            <div class="row mt-3">
                <div class="col-12 dealBtnStyle">
                     <button class="btn-new save-and-create-bid float-left ml-0" v-if="isEditable==false" @click="getMatchContacts()" data-toggle="modal" data-target="#matchContactsModal">{{$ml.get('MATCH_CONTACTS')}}</button>
                      <button class="btn-new save-and-create-bid float-left ml-0" v-else data-toggle="modal" data-target="#matchContactsModal">{{$ml.get('EDIT_MATCH_CONTACTS')}}</button>
                </div>
            </div>
            <div class="row mt-3" v-for="(item, index) in listPersons" :key="index">
              <div class="col-md-10 mx-3 listPerson">
                {{item.name}}
              </div>
              <div class="col-md-1 ml-2">
                <a class="btn btn-danger trash-icon" @click="deletePerson(index)">
                  <i class="far fa-trash-alt text-white"></i>
                </a>
              </div>
            </div>
            <div class="row mt-2">  
              <div class="col-12"> <label class="new-label">{{$ml.get('VALIDITY_DATE')}}*</label> </div>                         
              <div class="col-12 col-md-6">
                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="activityDateAction" class="new-ctk" v-model="activityDateAction" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true" :label="$ml.get('SELECT_DATE')"></vue-ctk-date-time-picker>
              </div>
              <div class="col-12 col-md-6 dealBtnStyle">
                <button class="btn-new save-and-create-bid float-left ml-0" @click="redirectToBidScreen()">{{$ml.get('REDIRECT_TO_BID_SCREEN')}}</button>
              </div> 
            </div>
            
            </div>
         <hr>
              <div class="row mt-4">
                <div class="col-12 dealBtnStyle" v-if="listenStateStatus===false">
                  <button class="btn-new save dropdown-toggle d-flex align-items-center justify-content-around" type="button" id="dropdownMenu3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{$ml.get('SAVE')}}</button>
                  <!-- <button class="btn-onizleme ml-2">{{$ml.get('PREVIEW')}}</button> -->
                  <button class="btn-new gri" @click="newDealChecker=true" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenu3">
                    <button class="dropdown-item" type="button" @click="saveAndEmail('save','quickOffer')" >{{$ml.get('SAVE_OFFER')}}</button>
                    <button class="dropdown-item" type="button" @click="saveAndEmail('saveAndEmail','quickOffer')" >{{$ml.get('SAVE_AND_EMAIL')}}</button>
                    <button class="dropdown-item" @click="saveOffer('print','quickOffer')" type="button">{{$ml.get('SAVE_AND_PRINT')}}</button>
                    <button class="dropdown-item" @click="saveOffer('download','quickOffer')" type="button">{{$ml.get('SAVE_AND_DOWNLOAD_PDF')}}</button>
                  </div>
                </div>
              </div>
        </div>

        <!-- Teklif oluşturma modalı başlangıç -->
        <div class="modal createBidModal" tabindex="-1" id="TeklifEkraniModal" data-backdrop="static" aria-labelledby="TeklifEkraniModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:990px!important; margin-top:0.1rem; margin-bottom:0.1rem;" >
            <div class="modal-content "  style="max-height:100%; position:fixed; overflow-y:hidden; overflow-x:hidden;">
              <div class="modal-header d-flex align-items-center py-0">
                  <h5 class="modal-title p-2 ">{{$ml.get('CREATE_OFFER')}}</h5>
                  <button type="button" class="close" @click="closeTeklifEkraniButton" aria-label="Close">
                       <span aria-hidden="true">&times;</span>
                  </button>
              </div>
                <div class="modal-body pt-5 px-md-4 " style="overflow:hidden auto">
            <div class="row mb-3">
                <div class="col-6 d-flex align-items-baseline">
                    <label class="new-label float-left black fs16 mx-2 ">{{$ml.get('CHOOSE_TEMPLATE')}}</label>
                     <select class="new-input bg-white ml-2" style="width:250px;" @change="chooseTemplate($event)">
                          <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                          <option v-for="template in emailTemplates" :value="template._id" :key="template._id" :selected="chosenTemplate===template._id">{{template.name}}</option>
                      </select>
                    </div>
                <div class="col-6 dealBtnStyle">
                      <button class="btn-new save-and-create-bid float-right ml-0" @click="createNewTemplate()">{{$ml.get('CREATE_NEW_TEMPLATE')}}</button>
                </div>
            </div>
            <div class="container borderr mx-1 my-1">
                <div class="row">
                    <div class="col-12">
                        <label class="new-label black fs16"><b>{{$ml.get('COMPANY_INFORMATION')}}</b></label>
                    </div>
                </div>
                <div class="row mb-2 pl-2 pb-2">
                    <!-- <div class="col-md-3">
                          <label class="new-label label-title-color float-left"><b>{{$ml.get('COMPANY_LOGO')}}</b></label>
                          <img src="" class="logo" alt="">
                    </div> -->
                    <div class="col-md-6 d-flex flex-column">
                         <label class="new-label label-title-color float-left"><b>{{$ml.get('YOUR_COMPANY_NAME')}}</b></label>
                         <label class="new-label company-info-color">{{organizationData.name}}</label>
                    </div>
                    <div class="col-md-6 d-flex flex-column">
                      
                          <label class="new-label label-title-color float-left"><b>{{$ml.get('YOUR_COMPANY_INFORMATION')}}</b></label>

                          <div class="row">
                            <label class="col-md-3 new-label label-title-color"><b>{{$ml.get('ADDRESS')}}:</b></label>
                            <div class="col-md-8 mt-2 pl-0">
                              <label class="new-label company-info-color mb-0 mt-0">{{organizationData.addr}}</label>
                            </div>
                          </div>

                          <div class="row">
                           <label class="col-md-3 new-label label-title-color float-left"><b>{{$ml.get('PHONE')}}:</b></label>
                           <div class="col-md-8 mt-2 pl-0">
                             <div v-for="i in organizationData.phoneNumbers">
                             <label class="new-label company-info-color mb-0 mt-0">{{i}}</label>
                           </div>
                           </div>
                          </div>
                          <div class="row">
                           <label class="col-md-3 new-label label-title-color float-left"><b>{{$ml.get('E_MAIL')}}:</b></label>
                           <div class="col-md-8 mt-2 pl-0">
                             <div v-for="i in organizationData.emailAddresses">
                             <label class="new-label company-info-color mb-0 mt-0">{{i}}</label>
                           </div>
                           </div>
                          </div>
                        
                    </div>
                </div>
            </div>

             <div class="container borderr mx-1 my-3">
                <div class="row">
                    <div class="col-12">
                          <label class="new-label black fs16"><b>{{$ml.get('OFFER')}}</b></label>
                    </div>
                </div>
                <div class="row">
                <div class="col-md-7 mb-2">
                    <div class="row my-1">
                        <div class="col-md-3">
                            <label class="new-label label-title-color fs16">
                                <b>{{$ml.get('OFFER_TITLE')}}</b></label>
                        </div>
                        <div class="col-md-9">
                            <input type="text" v-model="offerTitle" class="new-input label-desc-color h36">
                        </div>
                    </div>
                  <div class="row my-1">
                        <div class="col-md-3">
                            <label class="new-label label-title-color fs16">
                                <b>{{$ml.get('COMPANY_NAME')}}*</b></label>
                        </div>
                        <div class="col-md-9">
                            <input type="text" disabled="disabled" v-model="organizationData.name" class="new-input label-desc-color bg-date-not h36">
                        </div>
                  </div>
                 <div class="row my-1">
                        <div class="col-md-3">
                             <label class="new-label label-title-color fs16">
                                 <b>{{$ml.get('RELATED_PERSON')}}*</b></label>
                        </div>
                        <div class="col-md-9">
                          <div class="row mb-2" v-for="(item, index) in listPersons" :key="index">
                            <div class="col-md-7 ml-3 listPerson">
                              {{item.name}}
                            </div>
                            <div class="col-md-1 ">
                              <a class="btn btn-danger trash-icon hw36" @click="deletePerson(index)">
                                <i class="far fa-trash-alt text-white"></i>
                              </a>
                            </div>
                            <div class="col-md-1 ml-2">
                              <button class="btn-new btn-primary hw36 ml-2" data-toggle="modal" data-target="#matchContactsModal">
                                <span class="fa fa-plus "></span>
                              </button>
                            </div>
                          </div>  
                        </div>
                  </div>
                      <div class="row my-1">
                        <div class="col-md-3">
                             <label class="new-label label-title-color fs16">
                                 <b>{{$ml.get('RELATED_OPPORTUNITY')}}*</b></label>
                        </div>
                        <div class="col-md-9 d-flex">
                            <input type="text" disabled v-model="relatedDeal" class="new-input label-desc-color bg-date-not h36">
                        </div>
                  </div>
                      <div class="row my-1">
                        <div class="col-md-3">
                          <label class="new-label label-title-color fs16">
                            <b>{{$ml.get('BILLING_ADDRESS')}}</b></label>
                        </div>
                        <div class="col-md-9 d-flex">
                          <textarea v-if="!isEditableBill" type="text" v-model="billAddress" disabled class="new-textarea label-desc-color bg-date-not"></textarea>
                          <textarea v-if="isEditableBill" type="text" v-model="billAddress" class="new-textarea label-desc-color"></textarea>
                          <button v-if="!isEditableBill" @click="isEditableBill=!isEditableBill" class="btn-new btn-primary hw36 ml-2">
                            <span class="fa fa-pencil"></span>
                          </button>
                          <button v-if="isEditableBill" @click="isEditableBill=!isEditableBill" class="btn-new btn-success hw36 ml-2">
                            <span class="fas fa-check"></span>
                          </button>
                        </div>
                  </div>
                      <div class="row my-2">
                        <div class="col-md-3">
                            <label class="new-label label-title-color fs16">
                              <b>{{$ml.get('SHIPPING_ADDRESS')}}</b></label>
                        </div>
                        <div class="col-md-9 d-flex">
                          <textarea v-if="!isEditableShipping" type="text" v-model="shippingAddress" disabled class="new-textarea label-desc-color bg-date-not"></textarea>
                          <textarea v-if="isEditableShipping" type="text" v-model="shippingAddress" class="new-textarea label-desc-color"></textarea>
                          <button v-if="!isEditableShipping" @click="isEditableShipping=!isEditableShipping" class="btn-new btn-primary hw36 ml-2">
                              <span class="fa fa-pencil"></span>
                          </button>
                          <button v-if="isEditableShipping" @click="isEditableShipping=!isEditableShipping" class="btn-new btn-success hw36 ml-2">
                              <span class="fa fa-check"></span>
                          </button>
                        </div>
                  </div>
                </div>
                <div class="col-md-5" style="border-left:1px solid #D1D1D7;">
                        <div class="row my-1">
                         <div class="col-md-4">
                             <label class="new-label label-title-color fs16">
                                 <b>{{$ml.get('REFERENCE_NO')}}</b></label>
                        </div>
                            <div class="col-md-8 d-flex">
                              <input type="text" disabled v-model="referenceNo" class="new-input label-desc-color bg-date-not h36">
                            </div>
                      </div>
                        <div class="row my-1">
                         <div class="col-md-4">
                             <label class="new-label label-title-color fs16">
                                 <b>{{$ml.get('DATE')}}*</b></label>
                        </div>
                            <div class="col-md-8 d-flex">
                              <vue-ctk-date-time-picker disabled :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="bidCreationDate" class="new-ctk" v-model="bidCreationDate" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true" :label="$ml.get('SELECT_DATE')"></vue-ctk-date-time-picker>
                            </div>
                      </div>
                        <div class="row my-1">
                          <div class="col-md-4">
                             <label class="new-label label-title-color fs16">
                                <b>{{$ml.get('EXPIRY_DATE')}}*</b>
                              </label>
                          </div>
                            <div class="col-md-8 d-flex">
                              <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="bidCreationExpiryDate" class="new-ctk" v-model="activityDateAction" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true" :label="$ml.get('SELECT_DATE')"></vue-ctk-date-time-picker>
                            </div>
                      </div>
                        <div class="row my-1">
                          <div class="col-md-4">
                            <label class="new-label label-title-color fs16">
                              <b>{{$ml.get('CURRENCY')}}*</b>
                            </label>
                          </div>
                          <div class="col-md-8 d-flex">
                            <input type="text" disabled v-model="currencyText" class="new-input label-desc-color bg-date-not h36">
                          </div>
                        </div>
                        <div class="row my-1">
                          <div class="col-md-4">
                            <label class="new-label label-title-color fs16">
                              <b>{{$ml.get('TAX_ADMINISTRATION')}}</b>
                            </label>
                          </div>
                          <div class="col-md-8 d-flex">
                            <input type="text" disabled v-model="organizationData.taxOffice" class="new-input label-desc-color bg-date-not h36">
                          </div>
                        </div>
                         <div class="row my-1">
                         <div class="col-md-4">
                            <label class="new-label label-title-color fs16">
                              <b>{{$ml.get('TAX_NUMBER')}}</b>
                            </label>
                        </div>
                            <div class="col-md-8 d-flex">
                              <input type="text" disabled v-model="organizationData.taxNo" class="new-input label-desc-color bg-date-not h36">
                            </div>
                      </div>
                </div>
                </div>
            </div>
            <div class="container borderr mx-1 my-1">
                <div class="row">
                    <div class="col-12">
                        <label class="new-label black fs16"><b>{{$ml.get('START_TEXT')}}</b></label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-3 new-label text-dark">
                      <form>
                        <textarea name="editor1" id="editor1" rows="10" cols="80">
                          
                        </textarea>
                      </form>
                    </div>
                </div>
            </div>
             <div class="container borderr mx-1 my-3">
                <div class="row">
                    <div class="col-12">
                          <label class="new-label black fs16"><b>{{$ml.get('PRODUCT_ADD_AREA')}}</b></label>
                    </div>
                </div>
            <!-- TABLO OLUŞTURMA -->

            <div>
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>{{$ml.get('PRODUCT_CODE')}}</th>
                    <th>{{$ml.get('PRODUCT_NAME')}}</th>
                    <th>{{$ml.get('UNIT_PRICE')}}</th>
                    <th>{{$ml.get('PIECE')}}</th>
                    <th>{{$ml.get('DISCOUNT')}}%</th>
                    <th>KDV%</th>
                    <template v-for="tax in otherTaxes" :key="tax.id"><th>{{tax.name}}%</th></template>
                    <th>{{$ml.get('AMOUNT')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in productTableList">
                    <td>{{i.code}}</td>
                    <td>{{i.name}}</td>
                    <td>{{i.itemPrice.toFixed(2)}}</td>
                    <td>{{i.quantity}}</td>
                    <td>{{i.discountPercentage}}%</td>
                    <td v-if="i.tax">{{i.tax}}%</td>
                    <td v-else>0%</td>
                    <template v-for="(a, aIndex) in otherTaxes" :key="aIndex">
                      <td v-if="i && a && i[a.id]!==undefined ">{{i[a.id].value}}%</td>
                      <td v-else>0%</td>
                    </template>
                    <td>{{i.totalPrice.toFixed(2)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>



                      
                <div class="row d-flex justify-content-end">
                  <div class="col-md-6" >
                      <table class="table table-bordered product-add-price-table mt-4">
                        <tbody>
                            <tr>
                                <td class="thead-light text-center bg-date-not d-flex justify-content-start">
                                    <div class="d-flex align-items-center justify-content-center">
                                        <label class="switch heightSwitch mr-2">
                                            <input type="checkbox" v-model="showTotalPriceStatus">
                                            <span class="slider round true"></span>
                                          </label>
                                            <label class="black">{{$ml.get('TOTAL_AMMOUT')}}</label>
                                    </div>
                                </td>
                                <td class="text-right">{{totalProductAmount}}</td>
                            </tr>
                              <tr>
                                <td class="thead-light text-center bg-date-not d-flex justify-content-start">
                                    <div class="d-flex align-items-center justify-content-center">
                                        <label class="switch heightSwitch mr-2">
                                          <input type="checkbox" v-model="showTotalDiscountStatus">
                                          <span class="slider round true"></span>
                                        </label>
                                        <label class="black" >{{$ml.get('TOTAL_DISCOUNT')}}</label>
                                    </div>
                                </td>
                                <td class="text-right">{{totalDiscount}}</td>
                            </tr>
                            <tr>
                              <td class="thead-light text-center bg-date-not ">
                                <div class="d-flex align-items-center">
                                  <label class="black ml-5 pl-2" >{{$ml.get('SUB_TOTAL')}}</label>
                                </div>
                              </td>
                              <td class="text-right">{{totalAmount}}</td>
                            </tr>
                            <tr>
                              <td class="thead-light text-center bg-date-not pl-5">
                                  <div class="d-flex align-items-center ml-3">
                                    <label class="black" >Toplam KDV Tutarı</label>
                                  </div>
                              </td>
                              <td class="text-right">{{totalKDV}}</td>
                            </tr>
                              <tr>
                                <td class="thead-light text-center bg-date-not d-flex justify-content-start">
                                    <div class="d-flex align-items-center justify-content-center">
                                        <label class="switch heightSwitch mr-2">
                                            <input type="checkbox" v-model="showOtherTaxStatus">
                                            <span class="slider round true"></span>
                                          </label>
                                            <label class="black" >Diğer Vergiler Tutarı</label>
                                    </div>
                                </td>
                                <td class="text-right">{{totalTaxes}}</td>
                            </tr>
                              <tr>
                                <td class="thead-light  text-center bg-dark">
                                    <div class="d-flex align-items-center justify-content-center">
                                            <label class="text-white" >{{$ml.get('GRAND_TOTAL')}}</label>
                                    </div>
                                </td>
                                <td class="text-right">{{generalTotal}}</td>
                            </tr>
                        </tbody>
                     </table>
                  </div>
                </div>
                </div>
                
                <div class="container borderr mx-1 my-3">
                <div class="row">
                    <div class="col-12">
                          <label class="new-label black fs16"><b>{{$ml.get('CONDITIONS')}}</b></label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-3 new-label text-dark">
                      <form>
                        <textarea name="editor2" id="editor2" rows="10" cols="80">
                          
                        </textarea>
                      </form>
                    </div>
                </div>
            </div>
                 <div class="container borderr mx-1 my-3">
                <div class="row">
                    <div class="col-12">
                        <label class="new-label black fs16"><b>{{$ml.get('END_TEXT')}}</b></label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-3 new-label text-dark">
                      <form>
                        <textarea name="editor3" id="editor3" rows="10" cols="80">
                          
                        </textarea>
                      </form>
                    </div>
                </div>
            </div>
               <div class="container mx-1 my-3">
                <div class="row">
                    <div class="col-md 6 borderr mr-4">
                      <label class="new-label black fs16"><b>{{$ml.get('OFFERER')}}</b></label>
                      <div class="row my-2">
                          <div class="col-md-3">
                           <label class="new-label label-title-color fs16" >
                            <b>{{$ml.get('NAME')}}</b></label>
                          </div>
                          <div class="col-md-9 d-flex">
                            <input type="text" class="my-auto dealInput" v-model="offererName">
                          </div>
                      </div>
                      <div class="row mb-3">
                          <div class="col-md-3">
                           <label class="new-label label-title-color fs16" >
                              <b>{{$ml.get('TITLE')}}</b></label>
                          </div>
                          <div class="col-md-9 d-flex">
                             <input type="text" class="my-auto dealInput" v-model="offererTitle">
                          </div>
                      </div>
                    </div>
                    <div class="col-md 6 borderr">
                      <label class="new-label black fs16"><b>{{$ml.get('OFFERED_CUSTOMER')}}</b></label>
                       <div class="row my-2">
                          <div class="col-md-3">
                           <label class="new-label label-title-color fs16" >
                              <b>{{$ml.get('NAME')}}</b></label>
                          </div>
                          <div class="col-md-9 d-flex">
                             <input type="text" class="my-auto dealInput" v-model="customerName">
                          </div>
                      </div>
                         <div class="row mb-3">
                          <div class="col-md-3">
                           <label class="new-label label-title-color fs16" >
                              <b>{{$ml.get('TITLE')}}</b></label>
                          </div>
                          <div class="col-md-9 d-flex">
                            <input type="text" class="my-auto dealInput" v-model="customerTitle">
                          </div>
                      </div>
                   </div>
                </div>
            </div>
              <div class="row mt-4">
                  <div class="col-12 dealBtnStyle" v-if="listenStateStatus===false">
                  <button class="btn-new save dropdown-toggle d-flex align-items-center justify-content-around" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{$ml.get('SAVE')}}</button>
                  <button class="btn-new gri" @click="closeTeklifEkraniButton">{{$ml.get('CANCEL')}}</button>
                  <div class="dropdown">
                    <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                      <button class="dropdown-item" type="button" @click="saveAndEmail('save')" >{{$ml.get('SAVE_OFFER')}}</button>
                      <button class="dropdown-item" type="button" @click="saveAndEmail('saveAndEmail')" >{{$ml.get('SAVE_AND_EMAIL')}}</button>
                      <button class="dropdown-item" @click="saveOffer('print')" type="button">{{$ml.get('SAVE_AND_PRINT')}}</button>
                      <button class="dropdown-item" @click="saveOffer('download')" type="button">{{$ml.get('SAVE_AND_DOWNLOAD_PDF')}}</button>
                    </div>
                  </div>
                </div>
             </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Teklif oluşturma modalı bitiş -->

          <!--ilgili kişileri eşleştirme modalı başlangıç  -->
        <div class="modal fade" id="matchContactsModal" tabindex="-1" aria-labelledby="matchContactsModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:720px!important">
            <div class="modal-content">
              <div class="modal-header py-0 d-flex align-items-center">
                <h2 class="modal-title p-2 ">{{$ml.get('CHOOSE_CONTACTS_TO_SEND')}}</h2>
                <button type="button" class="close" @click="closeMatchContactButton" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
              </div>
                <div class="modal-body pt-5 px-md-4 ">
                    <div class="row mx-2 ">   
                      <div class="personTable">
                        <table class="table table-striped table-hover" id="contactTable">
                          <thead>
                            <tr>
                              <th>
                                <label class="form-checkbox">
                                  <input type="checkbox" v-model="selectAll" id="select-all" @click="selectPerson()">
                                  <i class="form-icon"></i>
                                </label>
                              </th>
                              <th>{{$ml.get('PERSON')}}</th>
                              <th>{{$ml.get('POSITION')}}</th>
                              <th>{{$ml.get('EMAIL')}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="i in personData">
                              <td>
                                <label class="form-checkbox">
                                  <input type="checkbox" :value="i._id.$oid" v-model="selected" >
                                  <i class="form-icon"></i>
                                  </label>
                              </td>
                              <td>{{i.n +" "+ i.sn}}</td>
                              <td>{{i.jobTitle}}</td>
                              <td v-if="i.email">{{i.email[0]}}</td>
                              <td v-else></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <hr>
                    <div class="row mt-4">
                          <div class="col-12 dealBtnStyle" v-if="listenStateStatus===false">
                            <button class="btn-new save" id="btnMatchContact" @click="matchContactsSave">{{$ml.get('SAVE')}}</button>
                            <button class="btn-new gri" @click="closeMatchContactButton">{{$ml.get('CANCEL')}}</button>
                        </div>
                    </div>
                </div>

            </div>
          </div>
        </div>
          <!-- ilgili kişileri eşleştirme modalı bitiş -->

          <!-- UYARI MODALI -->      
          <div class="modal" id="warningModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="warningModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body d-flex">
                   <div class="row mx-auto ">
                     <i class="col-md-12 fas fa-exclamation-circle my-3" style="font-size:80px; left:39%;"></i>
                     <div class="col-md-12 mb-3 text-center" id="warningModalTitle" style="font-weight:bold; font-size:16px;">{{$ml.get('SELECT_DATE')}}</div>
                     <div class="col-md-12 text-center" id="warningModalText" style="font-size:16px;">{{$ml.get('ENTER_DATE_TO_CREATE_OFFER')}}</div>
                   </div>
                </div>
                <div class="modal-footer d-flex">
                  <button type="button" class="btn btn-primary mx-auto" style="background:#3767A0;" @click="warningModalClose">{{$ml.get('COMPLETE')}}</button>
                </div>
              </div>
            </div>
          </div>


          <!-- Değişiklik uyarısı Modal -->
          <div class="modal fade h-100" id="changeAlertModal" tabindex="-1" role="dialog"   data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true" style="z-index:99999;">
              <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content px-2 py-3 bg-white" >
                      <div class="modal-body text-center">
                          <i class="fas fa-exclamation-circle danger fa-3x" style="background: #FF0000; color: #fff; padding: 1.5rem; border-radius: 50%;"></i>
                          <h2 class="my-3" style="color:#47495A;">Uyarı</h2>
                          <p style="color: #53565E; font-size: 16px;">
                              Değişiklikleri kaydetmek istiyor musunuz?
                          </p>
                      </div>
                      <div class="modal-footer d-flex align-items-center justify-content-center">
                          <button type="button" class="btn bg-transparent btn-lg mr-2" style="font-weight: 500; font-size: 16px;" data-dismiss="modal" @click="closeButtonModal()">{{$ml.get('NO')}}</button>
                          <button type="button" class="btn btn-lg" style="background: #FF0000; color: #fff; font-weight: 600; font-size: 16px;" data-dismiss="modal" @click="saveButton">{{$ml.get('YES')}}</button>
                      </div>
                  </div>
              </div>
          </div>
    </div>  
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import axios from "axios";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
Vue.component("vue-ctk-date-time-picker", VueCtkDateTimePicker);
import _ from "underscore";
import specialArea from "@/components/customField";
import showNotePanel from "@/components/showNotePanel";
import reminderPanel from "@/components/reminderPanel";
import Grid from "./Grid";
import GridMobil from "./gridMobil";
import file from '@/components/file'

export default {
  name: "newDeal",
  props: ["methods", "customFieldArray", "user", "users", "data", "modalClear"],
  components: {
    "special-area": specialArea,
    showNotePanel: showNotePanel,
    reminderPanel: reminderPanel,
    Grid,
    GridMobil,
    'file':file,
  },
  data() {
    return {
      watchUpdated:0,
      deal: {
        stageId: 1,
        status: 1,
        value: 0,
        currency: localStorage.defaultCurrency,
        rate: "0",
        source: "0",
        expectedDate: "",
        notes: [],
      },
      dealId: "",
      customerFiles:[],
      returnCustomField: [],
      items: [],
      productTableList:[],
      organizations: [],
      contacts: [],
      personData:[],
      organizationData:[],
      contactKeyword: "",
      contactKeySearch: true,
      selectContact: "",
      organizationsKeyword: "",
      organizationsWord:"",
      orgKeySearch: true,
      selectOrganization: "",
      relatedDeal:"",
      currencyValue:"",
      organizationId: "",
      productId: "",
      contactId: "",
      isHiddenContact: false,
      isHiddenOrganization: false,
      isHiddenProduct: false,
      lostReason: "",
      note: "",
      productKeyword: "",
      selectProduct: "",
      selectAll:false,
      selected:[],
      selectedPersons:[],
      listPersons:[],
      personIds:[],
      isEditable:false,
      isEditableBill:false,
      isEditableShipping:false,
      billAddress:"",
      shippingAddress:"",
      referenceNo:"",
      currencyText:"",
      product: [],
      selectedProductList: [],
      addContact: false,
      addOrg: false,
      addOrgArray: { isCandidate: true },
      addContactArray: [],
      isNewOrganization: false,
      addnote: "",
      soruceTitle: [
        { value: "0", label: this.$ml.get("SELECT") },
        {
          value: this.$ml.get("ADVERTISING"),
          label: this.$ml.get("ADVERTISING"),
        },
        {
          value: this.$ml.get("PHONE_CALL"),
          label: this.$ml.get("PHONE_CALL"),
        },
        {
          value: this.$ml.get("EMPLOYEE_ORUENTATION"),
          label: this.$ml.get("EMPLOYEE_ORUENTATION"),
        },
        {
          value: this.$ml.get("EXTERNAL_ORUENTATION"),
          label: this.$ml.get("EXTERNAL_ORUENTATION"),
        },
        {
          value: this.$ml.get("ONLINE_STORE"),
          label: this.$ml.get("ONLINE_STORE"),
        },
        {
          value: this.$ml.get("BUSINES_PARTNER"),
          label: this.$ml.get("BUSINES_PARTNER"),
        },
        {
          value: this.$ml.get("PUBLIC_RELATIONS"),
          label: this.$ml.get("PUBLIC_RELATIONS"),
        },
        { value: this.$ml.get("SEMINAR"), label: this.$ml.get("SEMINAR") },
        { value: this.$ml.get("FAIR"), label: this.$ml.get("FAIR") },
        { value: "Web", label: "Web" },
        { value: this.$ml.get("EMAILING"), label: this.$ml.get("EMAILING") },
        {
          value: this.$ml.get("SOCIAL_MEDIA"),
          label: this.$ml.get("SOCIAL_MEDIA"),
        },
        {
          value: this.$ml.get("AFFILIATE_PROGRAMS"),
          label: this.$ml.get("AFFILIATE_PROGRAMS"),
        },
        { value: this.$ml.get("SEO"), label: this.$ml.get("SEO") },
        {
          value: this.$ml.get("PAID_SEARCH"),
          label: this.$ml.get("PAID_SEARCH"),
        },
        {
          value: this.$ml.get("ONLINE_ADVERTISING"),
          label: this.$ml.get("ONLINE_ADVERTISING"),
        },
      ],
      rateTitle: [
        { value: "0", label: this.$ml.get("SELECT") },
        { value: "1", label: this.$ml.get("NORMAL") },
        { value: "2", label: this.$ml.get("PRIORITY") },
        { value: "3", label: this.$ml.get("URGENT") },
      ],
      customerType: [
        { value: true, label: this.$ml.get("LEAD") },
        { value: false, label: this.$ml.get("CUSTOMER") },
      ],
      currenciesData: [
        { value: "1", label: "TL" },
        { value: "2", label: "USD" },
        { value: "3", label: "EUR" },
        { value: "4", label: "AUD" },
        { value: "5", label: "DKK" },
        { value: "6", label: "GBP" },
        { value: "7", label: "CHF" },
        { value: "8", label: "SEK" },
        { value: "9", label: "CAD" },
        { value: "10", label:"KWD" },
        { value: "11", label:"NOK" },
        { value: "12", label:"SAR" },
        { value: "13", label:"JPY" },
        { value: "14", label:"BGN" },
        { value: "15", label:"RON" },
        { value: "16", label:"RUB" },
        { value: "17", label:"IRR" },
        { value: "18", label:"CNY" },
        { value: "19", label:"PKR" },
        { value: "20", label:"QAR" },
      ],
      orjinalProductList: [],
      reminders: [
        {
          day: "",
          time: "12:00",
          date: { $date: "" },
          isActive: true,
          isQueued: false,
          firstLoad: true,
        },
      ],
      //currencyData:[]
      customFieldDatas: [],
      newDealChecker: true,
      activityDateAction: "",
      gridColumns: [
        { prop: "_id", name: "Id" },
        {
          prop: "productCode",
          name: "Ürün Kodu",
          type: "productCode",
          default: true,
        },
        {
          prop: "productName",
          name: "Ürün Adı",
          type: "productName",
          default: true,
        },
        {
          prop: "unitPrice",
          name: "Birim Fiyatı",
          type: "unitPrice",
          default: true,
        },
        { prop: "number", name: "Adet", type: "number", default: true },
        { prop: "discount", name: "İndirim%", type: "discount", default: true },
        { prop: "KDV", name: "KDV%", type: "KDV", default: true },
        { prop: "ÖTV", name: "ÖTV%", type: "ÖTV", default: true },
        { prop: "amount", name: "Tutar", type: "date_updated", default: true },
      ],
      gridColumnsKisi: [
        { prop: "_id", name: "Id" },
        { prop: "person", name: "Kişi", type: "person", default: true },
        { prop: "position", name: "Pozisyon", type: "position", default: true },
        { prop: "email", name: "E-posta Adresi", type: "email", default: true },
      ],
      pageIs: "newDeal",
      gridData: [],
      gridDataKisi: [],
      tableConfigVisible: [
        "Id",
        "productCode",
        "productName",
        "unitPrice",
        "number",
        "discount",
        "KDV",
        "ÖTV",
        "amount",
      ],
      tableConfigVisibleKisi: ["Id", "person", "position", "email"],
      bidCreationDate: "",
      bidCreationExpiryDate: "",
      totalProductAmount:0,
      totalAmount:0,
      totalDiscount:0,
      totalTaxes:0,
      subTotal:0,
      totalKDV:0,
      totalOTV:0,
      generalTotal:0,
      emailTemplates:[],
      pdfUrl:[],
      chosenTemplate:"",
      offerDealId:"",
      offererName:"",
      offererTitle:"",
      customerName:"",
      customerTitle:"",
      offerTitle:"",
      editor1Text:"",
      editor2Text:"",
      editor3Text:"",
      showTotalPriceStatus:true,
      showTotalDiscountStatus:true,
      showOtherTaxStatus:true,
      refNo:"",
      otherTaxes:[],
      fileId:{},
    };
  },
  computed: {
    ...mapState([
      "baseUrl",
      "editLine",
      "maxMobilSize",
      "maxTabletSize",
      "windowWidth",
    ]),
    ...mapGetters(["localeLang"]),
    listenState() {
      return this.$store.state.editLine;
    },
    listenStateStatus() {
      return this.$store.state.editLineStatu;
    },
  },
  methods: {
    updateRemindersData(newReminders) {
      this.reminders = newReminders;
    },
    addNewFile(event){
        this.fileId=event
        console.log(this.fileId);
        this.customerFiles.unshift(event) 
    },
    changeCurrency(event) {
     
      for (var i in this.selectedProductList) {
        var getProductDetail = this.product.find(
          (p) => p._id.$oid == this.selectedProductList[i].productId.$oid
        );
        if (getProductDetail.prices !== undefined) {
          var productPrice = getProductDetail.prices.find(
            (p) => p.currency == this.deal["currency"]
          );
          if (productPrice) {
            this.selectedProductList[i].itemPrice = productPrice.price;
          } else {
            this.selectedProductList[i].itemPrice = 0;
          }
        } else {
          this.selectedProductList[i].itemPrice = 0;
        }
      }
      this.updateProductPriceList();
    },
    updateProductPriceList() {
      this.deal.value = 0;
      for (var i in this.selectedProductList) {
        if (this.selectedProductList[i].discountPercentage > 100) {
          this.selectedProductList[i].discountPercentage = 100;
        }
        if (this.selectedProductList[i].discountPercentage == "") {
          this.selectedProductList[i].discountPercentage = 0;
        }
        this.selectedProductList[i].totalPrice =
          this.selectedProductList[i].itemPrice *
            this.selectedProductList[i].quantity -
          (this.selectedProductList[i].itemPrice *
            this.selectedProductList[i].quantity *
            this.selectedProductList[i].discountPercentage) /
            100;

        this.deal.value =
          this.deal.value + this.selectedProductList[i].totalPrice;
        this.deal.value = parseFloat(this.deal.value.toFixed(2));
        this.selectedProductList[i].totalPrice = parseFloat(
          this.selectedProductList[i].totalPrice.toFixed(2)
        );
      }
    },
    saveOrgButton() {
      let url = "";
      let obj = {};
      let dataObj = {};
      let phone = [];
      if (this.addOrgArray["name"].length > 1) {
        obj["name"] = this.addOrgArray["name"];
      } else {
        this.$notify({
          group: "foo",
          type: "warn",
          title: "Firma adı boş olamaz!",
        });
        return false;
      }
      if (this.addOrgArray["phone"].length > 9) {
        phone.push(this.addOrgArray["phone"]);
        obj["phoneNumbers"] = phone;
      } else {
        this.$notify({
          group: "foo",
          type: "warn",
          title: this.$ml.get("WARPHONE_COMPANY_LEAST_10_DIGITSNING"),
        });
        return false;
      }
      obj["isCandidate"] = this.addOrgArray["isCandidate"];
      obj["status"] = true;
      url = "addOrganization";
      dataObj["organizationInputObj"] = obj;
      this.postOrganization(url, dataObj);
    },
    postOrganization(url, obj) {
      axios({
        method: "POST",
        url: `/${url}`,
        baseURL: this.baseUrl,
        data: obj,
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (!res.data.status) {
            this.$router.push("/logout");
          }
          if (res.data.status.code == 0) {
            this.$notify({
              group: "foo",
              type: "success",
              title: this.$ml.get("NEW_COMPANY_ADDED"),
              text: res.data.status.desc,
            });
            this.addOrgArray["phone"] = "";
            this.addOrg = false;
            this.isNewOrganization = true;
            this.organizationsKeyword = res.data.content.organization.name;
            this.isHiddenOrganization = false;
            this.organizationId = res.data.content.organization._id.$oid;
            this.selectOrganization = res.data.content.organization.name;
          } else {
            this.$notify({
              group: "foo",
              type: "error",
              title: this.$ml.get("ERROR"),
              text: res.data.status.desc,
            });
          }
        });
    },
    closeOrgButton() {
      this.addOrg = false;
      this.addContact = false;
      this.addOrgArray["phone"] = "";
      this.isHiddenContact = false;
    },
    relationButton() {
      this.addOrganizationContact();
    },
    relationCancelButton() {
      this.isNewOrganization = false;
    },
    addOrganizationContact() {
      axios({
        method: "POST",
        url: "/addOrganizationContact",
        baseURL: this.baseUrl,
        data: {
          objId: this.organizationId,
          newContactId: this.contactId,
        },
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (res.data.status.code == 0) {
            this.$notify({
              group: "foo",
              type: "success",
              title: this.$ml.get("COMPANY_AND_CONTACT_ASSOCIATED"),
              text: res.data.status.desc,
            });
            this.isNewOrganization = false;
          } else {
            this.$notify({
              group: "foo",
              type: "error",
              title: this.$ml.get("ERROR"),
              text: res.data.status.desc,
            });
          }
        });
    },
    addNoteFunc() {
      let dataObje = {};
      dataObje["dealId"] = this.dealId;
      dataObje["noteText"] = this.addNote;
      dataObje["note"] = this.addNote;
      dataObje["notePostUrl"] = "upsertDealNote";
      if (this.addNote === "") {
        this.$notify({
          group: "foo",
          type: "warn",
          title: this.$ml.get("NOTE_CANNOT_BE_EMPTY"),
          text: this.$ml.get("PLEASE_INSERT_A_VALID_NOTE"),
        });
        return false;
      }

      axios({
        method: "POST",
        url: "/addNote",
        baseURL: this.baseUrl,
        data: dataObje,
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (res.data.status.code == 0) {
            this.addNote = "";

            this.deal["notes"].push(res.data.content.note);

            this.$notify({
              group: "foo",
              type: "success",
              title: this.$ml.get("SUCCESSFUL"),
              text: res.data.status.desc,
            });
          } else {
            this.$notify({
              group: "foo",
              type: "warning",
              title: this.$ml.get("WARNING"),
              text: res.data.status.desc,
            });
          }
        });
    },
    saveContactButton() {
      let name = "",
        surName,
        phone,
        url,
        mail;
      let nameSplit = [];
      let dataObj = {};
      nameSplit = this.addContactArray["name"].split(" ");
      if (nameSplit.length - 1 > 0) {
        for (let index = 0; index < nameSplit.length - 1; index++) {
          name = name + " " + nameSplit[index];
        }
        surName = nameSplit[nameSplit.length - 1];
      } else {
        name = nameSplit[0];
      }
      phone = this.addContactArray["gsm"];
      mail = this.addContactArray["mail"];

      if (name.length > 0 && mail != null && phone != null) {
        if (phone.length < 9) {
          this.$notify({
            group: "foo",
            type: "warning",
            title: this.$ml.get("WARNING"),
            text: this.$ml.get("PHONE_NUMBER_SHOULD_BE_AT_LEAST_10_DIGITS"),
          });
        } else if (!this.validEmail(mail)) {
          return false;
        } else {
          url = "addContact";
          dataObj["contactInputObj"] = {
            n: name,
            sn: surName,
            gsm: phone,
            email: mail,
          };
          this.postContact(url, dataObj);
        }
      } else {
        this.$notify({
          group: "foo",
          type: "warning",
          title: this.$ml.get("WARNING"),
          text: this.$ml.get("REQUIRED_FIELDS_CANNOT_BE_BLANK"),
        });
      }
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (email.length > 0 && email !== undefined) {
        if (re.test(email) === false) {
          this.$notify({
            group: "foo",
            type: "warn",
            title: this.$ml.get("INVALID_EMAIL"),
            text: this.$ml.get("PLEASE_INSERT_A_VALID_EMAIL"),
          });
          return false;
        } else {
          return email;
        }
      } else {
        return false;
      }
    },
    postContact(url, obj) {
      axios({
        method: "POST",
        url: `/${url}`,
        baseURL: this.baseUrl,
        data: obj,
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (!res.data.status) {
            this.$router.push("/logout");
          }
          if (res.data.status.code == 0) {
            this.$notify({
              group: "foo",
              type: "success",
              title: this.$ml.get("NEW_CONTACT_ADDED"),
              text: res.data.status.desc,
            });
            this.isHiddenContact = false;
            this.addContact = false;
            this.addContactArray["gsm"] = "";
            this.contactId = res.data.content.contact._id.$oid;
            this.selectContact = res.data.content.contact.n;
            this.items = [];
            this.isNewOrganization = true;
          } else {
            this.$notify({
              group: "foo",
              type: "error",
              title: this.$ml.get("WARNING"),
              text: res.data.status.desc,
            });
          }
        });
    },
    closeContactButton() {
      this.addOrg = false;
      this.addContact = false;
      this.addContactArray["gsm"] = "";
      this.addContactArray["mail"] = "";
    },
    setResult(result, type) {
      if (type === "contact") {
        if (result.sn !== undefined) {
          this.contactKeyword = result.n + " " + result.sn;
          this.selectContact = result.n + " " + result.sn;
        } else {
          this.contactKeyword = result.n;
          this.selectContact = result.n;
        }
        this.isHiddenContact = false;
        this.contactId = result._id.$oid;

        if (result.organizationName !== undefined) {
          this.organizationId = result.organization.$oid;
          this.organizationsKeyword = result.organizationName;
          this.organizationsWord = result.organizationName;
          this.selectOrganization = result.organizationName;
        }
      }
      if (type === "organization") {
        this.organizationsKeyword = result.name;
        this.organizationsWord = result.name;
        this.isHiddenOrganization = false;
        this.organizationId = result._id.$oid;
        this.selectOrganization = result.name;
      }
      if (type === "product") {
 
        let originalProductObj = result
        let array =[]
        for (const property in result) {
          if(result[property].field_type===12){
            array.push(result[property])
          }
          originalProductObj['customFieldTaxes']=array
        }        
        this.orjinalProductList.push(originalProductObj);

        if (this.product.length < 1) {
          this.deal["value"] = null;
        }
        this.isHiddenProduct = false;
        this.productKeyword = "";
        this.productId = result._id.$oid;
        this.selectProduct = result.name;

        if (
          this.product.filter((m) => m._id.$oid === this.productId).length === 0
        ) {
          this.product.push(result);
          let obj = {};
          var currencyIs = false;

          for (var res in result.prices) {
            if (result.prices[res].currency == this.deal["currency"]) {
              currencyIs = true;
              this.deal["value"] += result.prices[res].price;
              this.deal["value"] = parseFloat(this.deal["value"].toFixed(2));
              this.deal["currency"] = result.prices[res].currency;
              obj["itemPrice"] = result.prices[res].price;
              obj["quantity"] = 1;
              obj["discountPercentage"] = 0;
              obj["totalPrice"] = result.prices[res].price;
              obj["productId"] = { $oid: this.productId };
            }
          }
          if (!currencyIs) {
            this.deal["value"] += 0;
            //this.deal['currency']=1
            obj["itemPrice"] = 0;
            obj["quantity"] = 1;
            obj["totalPrice"] = 0;
            obj["discountPercentage"] = 0;
            obj["productId"] = { $oid: this.productId };
          }
          this.selectedProductList.push(obj);
        }
      }
      this.getOrganization()
    },
    removeProduct(index) {
      this.product.splice(index, 1);
      this.selectedProductList.splice(index, 1);
      this.updateProductPriceList();
    },
    quickProduct() {
      axios({
        method: "POST",
        url: "/quickFilterProduct",
        baseURL: this.baseUrl,
        data: {
          search: this.productKeyword,
        },
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (!res.data.status) {
            this.$router.push("/logout");
          }
          if (res.data.status.code == 0) {
            this.items = res.data.content.products;
            this.isHiddenProduct = true;
          } else {
          }
        });
    },
    quickOrganization() {
      axios({
        method: "POST",
        url: "/quickFilterOrganization",
        baseURL: this.baseUrl,
        data: {
          search: this.organizationsKeyword,
        },
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (!res.data.status) {
            this.$router.push("/logout");
          }
          if (res.data.status.code == 0) {
            this.items = res.data.content.organizations;
            this.isHiddenOrganization = true;
          } else {
          }
        });
    },
    quickContact() {
      let obj = {};
      if (this.isNewOrganization) {
        obj["search"] = this.contactKeyword;
      } else {
        obj["search"] = this.contactKeyword;
        obj["organizationId"] = this.organizationId;
      }
      axios({
        method: "POST",
        url: "/quickFilterContact",
        baseURL: this.baseUrl,
        data: obj,
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (!res.data.status) {
            this.$router.push("/logout");
          }
          if (res.data.status.code == 0) {
            this.items = res.data.content.contacts;
            if (this.contactKeyword !== "" || this.organizationId !== "") {
              this.isHiddenContact = true;
            }
          } else {
          }
        });
    },
    selectPerson(){
      this.selected = [];
      this.selectedPersons = [];
			if (!this.selectAll) {
				for (let i in this.personData) {
          let obj = {}
          obj.id=this.personData[i]._id.$oid
          obj.name=this.personData[i].n + " " + this.personData[i].sn
          this.selectedPersons.push(obj)
					this.selected.push(this.personData[i]._id.$oid);
				} 
			}
      else{

      }
    },
    chooseTemplate(event){
      this.chosenTemplate=this.emailTemplates[event.target.selectedIndex-1]._id
    },
    saveAndEmail(type,quick){
      if(this.chosenTemplate===""){
        $('#warningModal').modal('show')
        document.getElementById("warningModalTitle").innerHTML="Şablon Seçin";
        document.getElementById("warningModalText").innerHTML="Teklifin gönderilmesi için şablon seçili olması gerekmektedir.";
      }
      else if(this.listPersons.length<1){
        $('#warningModal').modal('show')
        document.getElementById("warningModalTitle").innerHTML="Gönderilecek Kişi Seçin";
        document.getElementById("warningModalText").innerHTML="Teklifin gönderilmesi için ilgili kişi alanında en az bir kişinin seçili olması gerekmektedir.";
      }
      else if(this.activityDateAction===""){
       $('#warningModal').modal('show')
       document.getElementById("warningModalTitle").innerHTML="Tarih Girin";
       document.getElementById("warningModalText").innerHTML="Teklifin oluşturulması için tarih girilmesi gerekmektedir.";
      }
     
      this.saveOffer(type,quick)
    },
    saveOffer(type,quick){
      let obj = {};
      var emailHead = CKEDITOR.instances["editor1"].getData();
      var termsOfCondition = CKEDITOR.instances["editor2"].getData();
      var emailFooter = CKEDITOR.instances["editor3"].getData();

      if(quick==='quickOffer'){
        this.billAddress=this.organizationData.addr
        this.shippingAddress=this.organizationData.addr
      }

      if(this.personIds.length<1){
          for(let person in this.listPersons){
            this.personIds.push(this.listPersons[person].id)
          }
      }
      
      obj["templateId"] = this.chosenTemplate;
      obj["dealId"] = this.offerDealId;
      obj["offerTitle"] = this.offerTitle;
      obj["organizationId"] = this.organizationData._id.$oid;
      obj["contactIds"] = this.personIds;
      obj["expireDate"] = this.activityDateAction;
      obj["billingAddress"] = this.billAddress;
      obj["shipmentAddress"] = this.shippingAddress;
      obj["referenceNo"] = parseInt(this.referenceNo);
      obj["offerDate"] = this.bidCreationDate;
      obj["taxAdministration"] = this.organizationData.taxOffice;
      obj["taxNo"] = this.organizationData.taxNo;
      obj["emailHead"] = emailHead;
      obj["emailFooter"] = emailFooter;
      obj["termsOfCondition"] = termsOfCondition;
      obj["offererSignature"] = "";
      obj["offererName"] = this.offererName;
      obj["offererTitle"] = this.offererTitle;
      obj["customerSignature"] = "";
      obj["customerName"] = this.customerName;
      obj["customerTitle"] = this.customerTitle;
      obj["totalPrice"] = this.generalTotal;
      obj["showTotalPrice"] = this.showTotalPriceStatus;
      obj["showTotalDiscount"] = this.showTotalDiscountStatus;
      obj["showTotalOtv"] = this.showOtherTaxStatus;

      if(this.chosenTemplate===""){
        $('#warningModal').modal('show')
        document.getElementById("warningModalTitle").innerHTML="Şablon Seçin";
        document.getElementById("warningModalText").innerHTML="Teklifin gönderilmesi için şablon seçili olması gerekmektedir.";
      }
      else if(this.activityDateAction===""){
       $('#warningModal').modal('show')
       document.getElementById("warningModalTitle").innerHTML="Tarih Girin";
       document.getElementById("warningModalText").innerHTML="Teklifin oluşturulması için son geçerlilik tarihi girilmesi gerekmektedir.";
      }
      else{
        axios({
            method:'POST',
            url:'/addOffer',
            baseURL: this.baseUrl,
            data: obj,
            withCredentials:true
        }).then((res)=>{
            return res
        }).then((res)=>{
            if(res.data.status===false){
            this.$router.push('/logout')
            }
            if(res.data.status.code==0){
              this.$notify({
                group: "foo",
                type: "success",
                title: "Teklif Kaydedildi!",
                text: res.data.status.desc,
              });
              $("#TeklifEkraniModal").modal("hide");
              $("#matchContactsModal").modal("hide");
              this.newDealChecker=true
              this.closeButton()
  
              this.offerID=res.data.content.offer._id.$oid
              this.refNo=res.data.content.offer.referenceNo
              this.editor1Text=res.data.content.offer.emailHead
              this.editor2Text=res.data.content.offer.termsOfCondition
              this.editor3Text=res.data.content.offer.emailFooter

              if(type==='print'){
                this.printPdf()
              }
              else if(type==='download'){
                  this.downloadPdf()
              }
              else if(type==='saveAndEmail'){
                  this.sendEmail()
              }
              else{
                  this.clearOfferModule()
              }
              
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc 
                })
                  
            }
        })   

      }     
    },
    createPdf() {
      axios({
          method:'POST',
          url:'/createOfferPdf',
          baseURL: this.baseUrl,
          data: {
              templateId: this.chosenTemplate,
              offerId:this.offerID
          },
          withCredentials:true
      }).then((res)=>{
          return res
      }).then((res)=>{
          if(res.data.status === "OK" ){
              this.pdfUrl = []
              this.pdfUrl.push(res.data.url)
          }else{
              this.$notify({
                  group: 'foo',
                  type: 'error',
                  title: this.$ml.get('ERROR'),
                  text: res.data.status.desc
              })
          }
      })
    },
    sendEmail() {
      this.createPdf()
      
      this.personEmailsArray=[]
      for (let i in this.listPersons) {
        for(let j in this.personData){
          if(this.listPersons[i].id===this.personData[j]._id.$oid){
            this.personEmailsArray.push(this.personData[j].email[0])
          } 
        }
      } 

      let msg = this.editor1Text + "\n \n" + this.editor2Text + "\n \n" + this.editor3Text           

      setTimeout(() => {
          this.$router.push({ path: '/email', query: { 
            action: 'login' ,
            emailAddress: this.personEmailsArray ,
            subject: "Teklifiniz Oluşturuldu. RefNo: " + this.refNo ,
            message: msg,
            attachments: this.pdfUrl,
          }})
      }, 1500);      
    
    },
    printPdf() {
      axios({
        method:'POST',
        url:'/createOfferPdf',
        baseURL: this.baseUrl,
        data: {
          templateId: this.chosenTemplate,
          offerId: this.offerID
        },
        withCredentials:true
      }).then((res)=>{
          return res
      }).then((res)=>{
          if(res.data.status === "OK" ){
            var id = "iframe", frame = document.createElement("iframe");
            frame.setAttribute("id", id);
            frame.setAttribute("name", "printframe");
            frame.setAttribute("hidden", true);
            document.body.appendChild(frame);
            frame.onload = function() {
                setTimeout(function() {
                printframe.print()
                },1000)
            }
            frame.setAttribute("src", res.data.relative_url);
            this.clearOfferModule()
              
          } else {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: this.$ml.get('ERROR'),
              text: res.data.status.desc
            })
          }
        })
      },
      downloadPdf(){
        axios({
            method:'POST',
            url:'/createOfferPdf',
            baseURL: this.baseUrl,
            data: {
                templateId: this.chosenTemplate,
                offerId:this.offerID
            },
            withCredentials:true
        }).then((res)=>{
            return res
        }).then((res)=>{
            if(res.data.status === "OK" ){
                this.pdfUrl = []
                this.pdfUrl.push(res.data.url)
                window.open(res.data.url, '_blank')
                this.clearOfferModule()
            }else{
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc
                })
            }
        })
      },
    getMatchContacts() {
      this.isEditable=true
      this.organizationsWord=this.organizationsKeyword
      let obj = {};
        obj["search"] = '';
        obj["organizationId"] = this.organizationId;
        
      axios({
        method: "POST",
        url: "/quickFilterContact",
        baseURL: this.baseUrl,
        data: obj,
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (res.data.status.code == 0) {
          }
        });
    },
    getEmailTemplates() {
       axios({
         method:'POST',
         url:'/getEmailTemplates',
         baseURL: this.baseUrl,
         withCredentials:true
       }).then((res)=>{
         return res
       }).then((res)=>{
         if(res.data.status.code==="0"){
           this.emailTemplates = res.data.content.email_templates;
         }else{
           this.$notify({
             group: 'foo',
             type: 'error',
             title: this.$ml.get('ERROR'),
             text: res.data.status.desc
           })
         }
       })
     },
    getOrganization(){
      let id=this.organizationId   
      axios({
          method:'POST',
          url:'/getOrganization',
          baseURL: this.baseUrl,
          data: {
              organizationId:id,
          },
          withCredentials:true
      }).then((res)=>{
          return res
      }).then((res)=>{
          if(res.data.status===false){
          this.$router.push('/logout')
          }
          if(res.data.status.code==0){
            this.organizationData=res.data.content.organization
            this.personData=res.data.content.organization.contacts
                
          }else{
              this.$notify({ 
                  group: 'foo',
                  type: 'error', 
                  title: this.$ml.get('ERROR'),
                  text: res.data.status.desc 
              })
                
          }
      })
    },

    dataFilling(updateData) {
      if (!this.isEmpty(updateData)) {
        for (var key in updateData) {
          if (typeof updateData[key] !== "function") {
            if (
              updateData[key].val !== null &&
              key !== "_id" &&
              key !== "createdAt" &&
              updateData[key].val.$oid !== ""
            ) {
              this.deal[key] = updateData[key].val;
            }
          }
        }
        if (updateData._id.val.$oid !== undefined) {
          this.dealId = updateData._id.val.$oid;
        }
        if (updateData.x.val === null) {
          this.deal["x"] = false;
        } else {
          this.deal["x"] = updateData.x.val;
        }
      }

      if (this.deal["expectedDate"]) {
        this.deal["expectedDate"] = this.deal["expectedDate"]["$date"];
      }
      if (this.deal["orgId"]) {
        this.organizationsKeyword = this.deal["orgId"]["name"];
        this.organizationId = this.deal["orgId"]["_id"]["$oid"];
      }
      if (this.deal["contactId"]) {
        this.contactKeyword =
          this.deal["contactId"]["n"] + " " + this.deal["contactId"]["sn"];
        this.contactId = this.deal["contactId"]["_id"]["$oid"];
      }
      this.contactKeySearch = false;
      this.orgKeySearch = false;
    },
    isEmpty(obj) {
      if (obj == null) return true;
      if (obj.length > 0) return false;
      if (obj.length === 0) return true;
      if (typeof obj !== "object") return true;
      for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
      }

      return true;
    },
    saveButton() {
      let formatDate = new Date(this.deal["expectedDate"]);
      let obj = {};
      obj = this.deal;
      let url = "";
      let dataObj = {};
      if (this.deal["title"] === "") {
        this.$notify({
          group: "foo",
          type: "warn",
          title: this.$ml.get("DEALS_NAME_EMPTY"),
          text: this.$ml.get("PLEASE_ENTER_A_DEAL_NAME"),
        });
        setTimeout(() => {
          $(".crm-modal-body").css("display","block")
          $(".crm-modal-header").css("position","sticky")
          $(".crm-modal-footer").css("display","flex")
          $(".crm-modal-content").css("width","100% ")
      }, 300);
        return false;
      }

      if (this.organizationId === "" && this.contactId === "") {
        this.$notify({
          group: "foo",
          type: "warn",
          title: this.$ml.get("CONTACT_OR_COMPANY_NAME_EMPTY"),
          text: this.$ml.get(
            "PLEASE_EITHER_ENTER_CONTACT_NAME_OR_COMPANY_NAME"
          ),
        });
        setTimeout(() => {
          $(".crm-modal-body").css("display","block")
          $(".crm-modal-header").css("position","sticky")
          $(".crm-modal-footer").css("display","flex")
          $(".crm-modal-content").css("width","100% ")
        }, 300);
        return false;
      }
      if (this.deal["stageId"] === "") {
        this.deal["stageId"] = 1;
      }
      obj = {
        title: this.deal["title"],
        stageId: this.deal["stageId"],
        status: this.deal["status"],
      };

      for (var customId in this.returnCustomField) {
        if (typeof this.returnCustomField[customId] !== "function") {
          obj[customId] = this.returnCustomField[customId];
        }
      }
      if (this.deal["value"] !== "") {
        obj["value"] = this.deal["value"];
      }
       if (this.deal["value"] == "") {
        obj["value"] = 0;
      }
      if (this.note !== "") {
        obj["note"] = this.note;
      }
      if (this.deal["source"] !== "0") {
        obj["source"] = this.deal["source"];
      }
      if (this.deal["currency"] !== "") {
        obj["currency"] = parseInt(this.deal["currency"]);
      }
      if (this.deal["lostReason"] !== "") {
        obj["lostReason"] = this.deal["lostReason"];
      }
      if (this.deal["expectedDate"] !== "") {
        obj["expectedDate"] = {
          $date: formatDate,
        };
      }
      if (this.deal["rate"] !== "0") {
        obj["rate"] = parseInt(this.deal["rate"]);
      }
      if (this.contactId !== "") {
        obj["contactId"] = {
          $oid: this.contactId,
        };
      }
      if (this.organizationId !== "") {
        obj["orgId"] = {
          $oid: this.organizationId,
        };
      }
      if (this.product.length > 0) {
        obj["productList"] = this.selectedProductList;
      }

      if (this.listenStateStatus === false) {
        url = "addDeal";
        obj["customerFileIds"]=this.customerFiles
        console.log(obj["customerFileIds"]);
        dataObj["dealInputObj"] = obj;
        this.customerFiles=[]
      } else {
        url = "updateDeal";
        obj["customerFileIds"]=this.customerFiles
        dataObj["dealId"] = this.dealId;
        dataObj["organizationId"] = this.organizationId;
        dataObj["dealUpdateObj"] = obj;
        this.customerFiles=[]
      }
      this.addDeal(url, dataObj);
      setTimeout(() => {
          $(".crm-modal-body").css("display","block")
          $(".crm-modal-header").css("position","sticky")
          $(".crm-modal-footer").css("display","flex")
          $(".crm-modal-content").css("width","100% ")
      }, 300);

    },
    closeButton() {
      // $("#addDeal").modal("hide");
      // this.clear();
      if(
        this.deal['title']==undefined && 
        this.note=="" && 
        this.deal["source"] =="0" &&
        this.deal["rate"] =="0" && 
        this.deal["expectedDate"]=="" &&
        this.productKeyword=="" && 
        this.contactKeyword=="" && 
        this.deal["value"]=="0" && 
        this.organizationsKeyword=="" 
        ){
          $("#addDeal").modal("hide");
           this.clear();
      }
      else{
           $(".crm-modal-body").css("display","none")
           $(".crm-modal-header").css("position","absolute ")
           $(".crm-modal-footer").css("display","none ")
           $(".crm-modal-content").css("width","0 ")
           $('#changeAlertModal').modal('show')
          //  this.clear();
         }
         
    },
    closeButtonModal(){
      setTimeout(() => {
          $(".crm-modal-body").css("display","block")
          $(".crm-modal-header").css("position","sticky")
          $(".crm-modal-footer").css("display","flex")
          $(".crm-modal-content").css("width","100% ")
      }, 300);
      console.log("tıklandı");
         
       //$("#addDeal").modal("hide");
       // this.clear();
       //$(".modal-backdrop").style.display="none";
        //$(".modal-backdrop").modal("hide");
      
    
    },
    closeMatchContactButton() {
      $("#matchContactsModal").modal("hide");
    
    },
    createNewTemplate(){
      window.open('/emailTemplateEditor/' + 'new' , '_blank');
    },
    clearOfferModule(){
      this.bidCreationDate= "",
      this.bidCreationExpiryDate= "",
      this.activityDateAction="",
      this.totalProductAmount=0,
      this.totalAmount=0,
      this.totalDiscount=0,
      this.totalTaxes=0,
      this.subTotal=0,
      this.totalKDV=0,
      this.totalOTV=0,
      this.generalTotal=0,
      this.otherTaxes=[],
      this.listPersons=[],
      this.productTableList=[],
      this.chosenTemplate="",
      this.offerDealId="",
      this.offerTitle="",
      this.personIds=[],
      this.billAddress="",
      this.shippingAddress="",
      this.offererName="",
      this.offererTitle="",
      this.customerName="",
      this.customerTitle="",
      this.showTotalPriceStatus=true,
      this.showTotalDiscountStatus=true,
      this.showOtherTaxStatus=true,
      this.selected = [],
      this.selectedPersons = [],
      CKEDITOR.instances["editor1"].setData("");
      CKEDITOR.instances["editor2"].setData("");
      CKEDITOR.instances["editor3"].setData("");
      
    },
    matchContactsSave(){
      
      if(this.selectedPersons.length<1){
        this.listPersons=[]
        for(let i in this.selected){
          for(let j in this.personData){
            if(this.selected[i]===this.personData[j]._id.$oid){
              let obj = {}
              obj.id=this.personData[j]._id.$oid
              obj.name=this.personData[j].n + " " + this.personData[j].sn
              this.listPersons.push(obj)
            }
          }
        }
      }
      else{
        this.listPersons=[]
        this.listPersons=this.selectedPersons
      }
      

      $("#matchContactsModal").modal("hide");
    },
    closeTeklifEkraniButton() {
      $("#TeklifEkraniModal").modal("hide");
      this.clear();
    },
    redirectToBidScreen(){

      for(let i in this.productTableList){
        if(this.productTableList[i].customFieldTaxes.length>0){
          let item = this.productTableList[i].customFieldTaxes
          for(let j in item){
            let obj = {}
            obj.name = item[j].name
            obj.id = item[j]._id
            if (this.otherTaxes.filter(function(e) { return e.name === item[j].name; }).length > 0) {

            }
            else{
              this.otherTaxes.push(obj)
            }
          }
        }
      }
      
      if(this.listPersons.length<1){
        $('#warningModal').modal('show')
        document.getElementById("warningModalTitle").innerHTML="Gönderilecek Kişi Seçin";
        document.getElementById("warningModalText").innerHTML="Teklifin gönderilmesi için ilgili kişi alanında en az bir kişinin seçili olması gerekmektedir.";
      }
      else{
        for(let person in this.listPersons){
          this.personIds.push(this.listPersons[person].id)
        }
      
        $("#TeklifEkraniModal").modal("show");
        this.referenceNo=Math.floor(Math.random() * 899999 + 100000)
        this.billAddress=this.organizationData.addr
        this.shippingAddress=this.organizationData.addr
        this.bidCreationDate=new Date().toISOString().slice(0, 10)
        for(let i in this.currenciesData){
          if(this.currenciesData[i].value==this.deal['currency']){
            this.currencyText=this.currenciesData[i].label
          }
        }
        
      }
    },
    deletePerson(index){
      if(this.listPersons.length>1){
        this.selected.splice(index,1)
        this.listPersons.splice(index,1)
      }
      else{
        this.$notify({
          group: "foo",
          type: "warn",
          title: "Kişi alanında en az bir kişinin seçili olması gerekmektedir!",
        });
      }
    },
    clear() {
      (this.deal = {}), (this.organization = {}), (this.lostReason = "");
      (this.deal = {
        stageId: 1,
        status: 1,
        value: 0,
        currency: localStorage.defaultCurrency,
        rate: "0",
        source: "0",
        expectedDate: "",
        notes: [],
      }),
        (this.note = ""),
        (this.addNote = ""),
        (this.organizationId = "");
      this.organizationsKeyword = "";
      this.contactKeyword = "";
      this.contactId = "";
      (this.product = []),
        (this.selectedProductList = []),
        (this.isNewOrganization = false);
      (this.isHiddenContact = false),
        (this.reminders = [
          {
            day: "",
            time: "12:00",
            date: { $date: "" },
            isActive: true,
            isQueued: false,
          },
        ]),
        setTimeout(() => {
          $("#deal-tab").tab("show");
        }, 500);
        

      setTimeout(() => {
        this.$refs.customFields.clearCustom();
      }, 0);

    },
    addDeal(url, obj) {
      axios({
        method: "POST",
        url: `/${url}`,
        baseURL: this.baseUrl,
        data: obj,
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (!res.data.status) {
            this.$router.push("/logout");
          }
          if (res.data.status.code == 0) {
            
            this.offerDealId=res.data.content.deal._id.$oid
            this.$emit("getData", res.data.content.deal);
            this.upsertRemindersF(res.data.content.deal._id.$oid);
            this.customFieldDatas = res.data.content
            if (this.listenStateStatus === false) {
               Object.keys(this.returnCustomField).forEach(key => {
                            delete this.returnCustomField[key];
                        })
              this.$notify({
                group: "foo",
                type: "success",
                title: this.$ml.get("DEAL_ADDED"),
                text: res.data.status.desc,
              });
            } else {
              this.deal = {};
              this.$store.state.editLine = [];
              this.$notify({
                group: "foo",
                type: "success",
                title: this.$ml.get("DEAL_HAS_BEEN_UPDATED"),
                text: res.data.status.desc,
              });
            }
            if(this.newDealChecker==true){
              // this.closeButton();
              $("#addDeal").modal("hide");
              this.clear();
            }
            
          } else {
          }
        });
    },
    formatUpsertList(originalList, dealId) {
      const keys = ["date", "isActive", "isQueued"];

      const result = (array) =>
        array.map((o) =>
          keys.reduce((acc, curr) => {
            acc[curr] = o[curr];
            acc.dealId = {};
            acc.dealId.$oid = dealId;
            return acc;
          }, {})
        );
      return result(originalList);
    },
    upsertRemindersF(dealId) {
      var remindersMutation = this.reminders.filter((r) => {
        return r.date.$date !== "";
      });
      if (remindersMutation.length > 0) {
        var form = {};
        form.objs = this.formatUpsertList(remindersMutation, dealId);
        this.upsertReminder(form)
          .then((res) => {
            return res;
          })
          .then((res) => {
       
            if (res.status.code !== "0") {
              this.$notify({
                group: "foo",
                type: "warning",
                title: this.$ml.get("WARNING"),
                text: res.status.desc,
              });
            }
          });
      }
    },
    selectStage: function (event) {
      this.deal["stageId"] = parseInt(event.srcElement.parentElement.id);
    },
    ...mapActions(["updateDealId", "updateLoading", "upsertReminder"]),
    completeInfo(data) {
      if (data !== undefined) {
        this.organizationsKeyword = data.name;
        this.isHiddenOrganization = false;
        this.organizationId = data._id.$oid;
        this.selectOrganization = data.name;
      }
    },

    openSaveAndCreateModal(){
      
      this.getEmailTemplates()
      
      if(this.organizationsKeyword===""){
        $('#warningModal').modal('show')
        document.getElementById("warningModalTitle").innerHTML="Firma Adı Girin";
        document.getElementById("warningModalText").innerHTML="Teklifin oluşturulması için firma adının girilmesi gerekmektedir.";
      }
      else if(this.selectedProductList.length<1){
        $('#warningModal').modal('show')
        document.getElementById("warningModalTitle").innerHTML="Ürün Ekleyin";
        document.getElementById("warningModalText").innerHTML="Teklifin oluşturulması için ürün eklenmesi gerekmektedir.";
      }
      else{ 
        
        for(let i=0; i<this.selectedProductList.length; i++){
          let a = this.selectedProductList[i]
          let b = this.orjinalProductList[i]
          let kdvPrice,total,discount,totalTaxes = 0
      
          this.totalProductAmount += a.itemPrice*a.quantity

          // FOR CALCULATION OF KDV PRICE
          if(this.orjinalProductList[i].tax){
            kdvPrice = (a.totalPrice*this.orjinalProductList[i].tax)/100
          }
          else{
            kdvPrice = 0
          }

          // FOR CALCULATION OF CUSTOMFIELD TAXES
          if(this.orjinalProductList[i].customFieldTaxes.length>0){
            let item = this.orjinalProductList[i].customFieldTaxes
            for(let j in item){
              totalTaxes+= (item[j].value*a.totalPrice)/100
            }
            
          }
          
          

          total=a.totalPrice
          discount=(a.itemPrice*a.quantity*a.discountPercentage)/100

          a.totalPrice=a.totalPrice+kdvPrice+totalTaxes
          this.totalKDV+=kdvPrice
          this.totalTaxes+=totalTaxes
          this.totalDiscount+=discount
          this.totalAmount+=total
         
          let item = {...a, ...b}
          this.productTableList.push(item)
        }
        
        this.generalTotal=(this.totalProductAmount-this.totalDiscount+this.totalKDV+this.totalTaxes).toFixed(2)
        this.totalKDV=this.totalKDV.toFixed(2)
        this.totalTaxes=this.totalTaxes.toFixed(2)
        this.totalDiscount=this.totalDiscount.toFixed(2)
        this.totalAmount=this.totalAmount.toFixed(2)
        
        this.newDealChecker = false;
        this.relatedDeal = this.deal['title']
        this.getOffers()
        this.saveButton()
      }
      
    },
    warningModalClose(){
      $('#warningModal').modal('hide')
    },
  
    scrollfunctionOfGrid: function (
      scrollYEmit,
      clientHeightEmit,
      scrollHeightEmit
    ) {
      this.bottom = this.bottomVisible(
        scrollYEmit,
        clientHeightEmit,
        scrollHeightEmit
      );
    },
    bottomVisible(scrollYEmit, clientHeightEmit, scrollHeightEmit) {
      const scrollY = scrollYEmit;
      const visible = clientHeightEmit;
      const pageHeight = scrollHeightEmit;
      const bottomOfPage = visible + scrollY >= pageHeight;

      return bottomOfPage || pageHeight < visible;
    },
    getOffers(){
      
      axios({
          method:'POST',
          url:'/getOffers',
          baseURL: this.baseUrl,
          withCredentials:true
      }).then((res)=>{
              return res
      }).then((res)=>{


          if(res.data.status.code==0){

          }else{
              this.$notify({ 
                  group: 'foo',
                  type: 'error', 
                  title: this.$ml.get('ERROR'),
                  text: res.data.status.desc 
              })
          }
      })
    },

  },
  mounted() {
    $(".mincrm-dynamic-tabs").bootstrapDynamicTabs();
    $('.modal').attr('tabindex', '');
    CKEDITOR.replace('editor1', {
      height: 150,
      toolbarGroups: 
          [
              {
              "name": "basicstyles",
              "groups": ["basicstyles"]
              }, 
              { 
              "name": 'clipboard', 
              "groups": [ 'undo' ] },  
              { 
              "name": 'paragraph',
              "groups": ['align'] },
              {
              "name": "styles",
              "groups": ["styles"]
              },
              {
              "name": 'colors', 
              "groups": [ 'colors' ] 
              },
              {
              "name": 'insert', 
              "groups": [ 'insert' ] 
              },
              { 
              "name": 'links',
              "groups": [ 'links' ] 
              },
          ],

      removeButtons: 'Copy,Paste,PasteFromWord,PasteText,Subscript,Superscript,Styles,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe'
    });
    CKEDITOR.replace('editor2', {
      height: 150,
      toolbarGroups: 
          [
              {
              "name": "basicstyles",
              "groups": ["basicstyles"]
              }, 
              { 
              "name": 'clipboard', 
              "groups": [ 'undo' ] },  
              { 
              "name": 'paragraph',
              "groups": ['align'] },
              {
              "name": "styles",
              "groups": ["styles"]
              },
              {
              "name": 'colors', 
              "groups": [ 'colors' ] 
              },
              {
              "name": 'insert', 
              "groups": [ 'insert' ] 
              },
              { 
              "name": 'links',
              "groups": [ 'links' ] 
              },
          ],

      removeButtons: 'Copy,Paste,PasteFromWord,PasteText,Subscript,Superscript,Styles,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe'
      
    });
    CKEDITOR.replace('editor3', {
      height: 150,
      toolbarGroups: 
          [
            {
            "name": "basicstyles",
            "groups": ["basicstyles"]
            }, 
            { 
            "name": 'clipboard', 
            "groups": [ 'undo' ] },  
            { 
            "name": 'paragraph',
            "groups": ['align'] },
            {
            "name": "styles",
            "groups": ["styles"]
            },
            {
            "name": 'colors', 
            "groups": [ 'colors' ] 
            },
            {
            "name": 'insert', 
            "groups": [ 'insert' ] 
            },
            { 
            "name": 'links',
            "groups": [ 'links' ] 
            },
          ],

      removeButtons: 'Copy,Paste,PasteFromWord,PasteText,Subscript,Superscript,Styles,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe'
      
    });
  },
  watch: {
    organizationsKeyword: _.debounce(function (addr) {
      this.addOrgArray["name"] = this.organizationsKeyword;
      this.closeOrgButton();
      if (
        this.selectOrganization !== this.organizationsKeyword &&
        this.orgKeySearch
      ) {
        this.isHiddenContact = false;
        this.quickOrganization();
      }
      if (this.organizationsKeyword === "") {
        this.isHiddenOrganization = false;
        this.organizationId = "";
      }
      this.orgKeySearch = true;
    }, 300),
    contactKeyword: _.debounce(function () {
      this.addContactArray["name"] = this.contactKeyword;
      this.closeContactButton();
      if (this.contactKeyword === "") {
        this.isHiddenContact = false;
        this.contactId = "";
      } else {
        if (
          this.selectContact !== this.contactKeyword &&
          this.contactKeySearch
        ) {
          this.isHiddenOrganization = false;
          this.quickContact();
        }
      }
      this.contactKeySearch == true;
    }, 300),
    productKeyword: _.debounce(function (addr) {
      if (this.productKeyword === "") {
        this.isHiddenProduct = false;
      }
      if (this.selectProduct !== this.productKeyword) {
        this.quickProduct();
      }
    }, 300),
    data: {
      handler: function (val, oldVal) {
        this.completeInfo(this.data);
      },
      deep: true,
    },
    modalClear: function (val) {
      if (val) {
        this.clear();
      }
    },
    listenState(data) {
      this.clear();
      if (
        this.$route.path === "/deals" ||
        this.$route.path === "/opportunities"
      ) {
        this.dataFilling(data);
      }
    },
    listenStateStatus(data) {
      if (data === false) {
        this.$store.state.editLine = [];
        this.clear();
      }
    },
  },
  created() {
    //this.currencyData = this.getCurrencyData()
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.my-custom-scrollbar {
  position: relative;
  height: 200px;
  overflow: auto;
}
.btn-dealStatus{
  border: 1px solid rgba(51, 51, 51, 0.10);
}
label{
    margin-bottom: 4px;
}
.tabloilk {
  width: 100%;
}
.table-wrapper-scroll-y {
  display: block;
}
.h36 {
  height: 36px;
}
.hw36 {
  height: 36px;
  width: 36px;
}
.gri {
  color: #9098a1;
}
.btn-onizleme {
  border: 2px solid #1991eb;
  box-sizing: border-box;
  border-radius: 6px;
  color: #1991eb;
}
.save-and-create-bid {
  /* background-color: #3767a0;
  color: white; */
  border: 1px solid #1991eb;
  color: #1991eb;
}
.black {
  color: #000000;
}
.fs16 {
  font-size: 16px;
}
.logo {
  width: 149px;
  height: 102px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}
.borderr {
  border: 1px solid #a5abb3;
  box-sizing: border-box;
  border-radius: 8px;
}
.label-title-color {
  color: #7e8187;
}
.label-desc-color {
  color: #354052;
}
.company-info-color {
  color: #93959a;
}
/* .product-add-price-table tr td{
    width:185px;
} */
.currency-group > input {
  width: 200px;
}
.currency-group > select {
  background-color: #dedfe1;
  height: 34px;
}
.modal-header {
  /* background-color: #d7e3f4; */
  position: sticky;
  top: 0;
  z-index: 1;
}
.modal-header li {
  font-size: 16px;
  margin-right: 5px;
}
.modal-header li a {
  color: #93959a;
  text-decoration: none;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 13px;
}
.modal-header li a.active {
  color: #5b5f63;
  font-weight: bold;
  border-bottom: 3px solid #1991eb;
}

.dealStatus div.statu {
  padding: 0;
}
.dealStatus .statu .active {
  color: white;
}
.dealStatus div.statu:nth-child(1) .active {
  background-color: #53a3f2;
}
.dealStatus div.statu:nth-child(2) .active {
  background-color: #3c89d8;
}
.dealStatus div.statu:nth-child(3) .active {
  background-color: #2f6aa8;
}
.dealStatus div.statu:nth-child(4) .active {
  background-color: #214c78;
}

.mcTable {
  border-spacing: 0;
  width: 100%;
  text-align: center;
}
.mcTable tbody {
  background-color: #dde0e4;
}
.mcTable thead {
  background-color: #fff;
}
.mcTable tr {
  margin-right: 3px;
}
.mcTable thead tr th {
  padding: 9px 4px;
  margin-right: 3px;
  font-size: 11px;
  color: #53565e;
}
.mcTable tbody tr {
  border-bottom: 0.5px solid #bec0c3;
}
.mcTable tbody tr:last-child {
  border: none;
}
.mcTable tbody tr td:last-child {
  cursor: pointer;
}
.mcTable tbody tr td {
  margin-right: 3px;
  font-size: 11px;
  padding: 7px 3px;
}

.dealStatus div.statu:first-child button {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.dealStatus div.statu:last-child button {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.dealStatus div.statu button {
  border-radius: 0;
}
.personTable {
  min-height: 350px;
  min-width: 655px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 4px;
}
.listPerson {
  display: flex;
  background: #E9EAEB;
  border: 1px solid #d6d6d6;
  border-radius: 4px;
  align-items: center;
}
.dealInput{
  height: 30px;
  width: 200px;
  border: 1px solid rgb(206, 205, 205);
  border-radius: 3px;
}

@media (min-width: 768px) {
  .dealStatus div.statu button {
    padding: 10px;
    border-radius: 0;
    background-color: #eceff5;
    color: #354052;
  }
  .dealStatus div.statu button:after {
    content: "";
    /* border-right: 0.5px solid #979797; */
    position: absolute;
    right: 0;
    height: 70%;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
  }
  .dealStatus div.statu:last-child button:after {
    border: 1px solid transparent;
  }
  .btnFooterDesktop{
    display: none;
  }
}

@media (max-width: 769px){
  .btnFooterMobil{
    display: none;
  }
}
@media (max-width: 768px) {
  .dealStatus div.statu button {
    background-color: inherit;
    color: #7e8086;
    font-size: 13px !important;
  }
   .save-and-create-bid{
    width: 100% !important;
    margin-top: 4px;
  }
 
}
</style>
